import logger from '@finn-no/fiaas-logger';
import type { NextPage } from 'next';
import { getPageCounter } from 'shared/prometheus/prometheus';
import type { SspContext } from 'shared/types';
import { fetchOffers } from '@/api/fetcher';
import { ResultPageLayout } from '@/components/ResultPageLayout';
import { config, feConfig } from '@/config';
import { browserQueryParamsToFilters, filtersToApiQueryParams } from '@/lib/utils/queryParamFilterConversions';
import { runAllMiddlewares } from '@/server/middleware';
import { actions as filterActions } from '@/state/filterActions';
import { actions as resultActions } from '@/state/resultActions';
import { wrapper } from '@/state/store';

const ResultPage: NextPage = (props) => {
    wrapper.useHydration(props);

    return <ResultPageLayout />;
};

export const getServerSideProps = wrapper.getServerSideProps((store) => async ({ req, res, query }: SspContext) => {
    if (query.skipSSRData) {
        return { props: { hasLegalBasis: false, unleash: null, config: feConfig } };
    }

    await runAllMiddlewares(req, res, query);

    const filters = browserQueryParamsToFilters(query);
    store.dispatch(filterActions.filter(filters));

    try {
        const data = await fetchOffers(config.get('pp.apiUrlInternal'), filtersToApiQueryParams(filters));
        store.dispatch(resultActions.setResults(data));
    } catch (error) {
        store.dispatch(resultActions.setError());
        logger.error(`Failed to fetch offers for result page: ${error}`);
    }

    getPageCounter().inc({ app: 'pale-pp-web', page: 'result' });

    return {
        props: {
            hasLegalBasis: res.locals?.hasLegalBasis ?? false,
            unleash: res.locals?.unleash ?? null,
            config: feConfig,
        },
    };
});

export default ResultPage;
